"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.explorerColumnDefaultPresetsByType = void 0;
var explorerColumnPresetGroupsDefault_1 = require("Modules/explorers/constants/explorerColumnPresetGroupsDefault");
var explorerColumnPresetUsersDefault_1 = require("Modules/explorers/constants/explorerColumnPresetUsersDefault");
var ExplorerColumnPresetType_1 = require("Modules/explorers/types/ExplorerColumnPresetType");
exports.explorerColumnDefaultPresetsByType = (_a = {},
    _a[ExplorerColumnPresetType_1.ExplorerColumnPresetType.users] = explorerColumnPresetUsersDefault_1.explorerColumnPresetUsersDefault,
    _a[ExplorerColumnPresetType_1.ExplorerColumnPresetType.groups] = explorerColumnPresetGroupsDefault_1.explorerColumnPresetGroupsDefault,
    _a[ExplorerColumnPresetType_1.ExplorerColumnPresetType.library] = {
        id: 0,
        name: "default",
        columns: [],
        type: ExplorerColumnPresetType_1.ExplorerColumnPresetType.library,
        created_at: "",
        updated_at: "",
        provider_id: 0,
    },
    _a);
